<div id="award">
  <div class="container-fluid">
      <div class="row">
          <div class="col-12">
              <div class="card shadow-lg inner-card">
                  <h4 class="card-title text-center">Inter-House Results</h4>
                  <div class="card-body">
                    <p class="inner-lead">Welcome to our school's Inter-House Results page! Our inter-house competitions are an integral part of our school's culture and provide an opportunity for students to showcase their skills and talents in a competitive environment.
                    </p>  
                    <p class="inner-lead">Our inter-house competitions range from sports and athletics to cultural events and academic competitions. Through these competitions, our students develop a range of skills, including leadership, teamwork, and time-management.
                    </p>
                    <p class="inner-lead">We take great pride in the success of our inter-house teams and celebrate their achievements with great enthusiasm. Our inter-house results page showcases the success of our students in various competitions, highlighting their hard work, dedication, and perseverance. We believe that recognizing our students' accomplishments is essential for motivating them to continue to strive for excellence and achieve their goals.
                    </p>
                  </div>
              </div>

          </div>
      </div>

     
  </div>
</div>